// extracted by mini-css-extract-plugin
module.exports = {"grid_table":"_1c_8Rqt"};